import { Environments } from '@innovyze/lib_get_service';

const config: any = {
	[Environments.LOCAL]: {
		amRehab: 'https://saas-rehab-management.info360-dev.com/dev',
		amInspection: 'https://saas-inspection-management.info360-dev.com/dev',
		amRisk: 'https://saas-risk-management.info360-dev.com/dev',
	},
	[Environments.DEV]: {
		amRehab: 'https://saas-rehab-management.info360-dev.com/dev',
		amInspection: 'https://saas-inspection-management.info360-dev.com/dev',
		amRisk: 'https://saas-risk-management.info360-dev.com/dev',
	},
};

export const apiEnv =
	(localStorage.getItem('apiEnv') as keyof typeof Environments) || undefined;

export default config;
